import React from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ShipmentLabelDetailsWrapper from '../shipmentLabelDetails/ShipmentLabelDetailsWrapper';
import useShipmentLabelDetailsDialog from 'hooks/dialogs/useShipmentLabelDialog';

const ShipmentLabelDetailsDialog: React.FC<{ open: boolean }> = (props) => {
    const shipmentLabelDetailsDialog = useShipmentLabelDetailsDialog();

    if (!props.open) {
        return <></>;
    }

    return (
        <>
            <Dialog
                open={props.open}
                onClose={shipmentLabelDetailsDialog.closeDialog}
                maxWidth={'lg'}
                fullWidth
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    <CloseIcon
                        sx={{ cursor: 'pointer' }}
                        onClick={shipmentLabelDetailsDialog.closeDialog}
                    />
                </DialogTitle>
                <ShipmentLabelDetailsWrapper />
            </Dialog>
        </>
    );
};

export default ShipmentLabelDetailsDialog;
